export { Cstretchmodal } from './Cstretchmodal';
export type { CstretchmodalProps } from './Cstretchmodal';
